import React, { FC } from "react";
import classNames from "classnames";
import { IRichText, TextType } from "@app/models/storyblok/basic";
import { IAmbassador } from "@app/models/storyblok/blocks/ambassador";
import { Hero } from "./components/hero/Hero";
import { List } from "./components/list/List";

type Props = {
  title: IRichText<TextType>;
  text: IRichText<TextType>;
  ambassadorsList: IAmbassador[];
};

export const Ambassadors: FC<Props> = ({ title, text, ambassadorsList }) => (
  <div
    className={classNames(
      "mt-20 flex flex-col items-center gap-y-20",
      "lg:mt-25 lg:gap-y-25",
      "xl:mt-40 xl:gap-y-40",
    )}
  >
    <Hero {...{ title, text }} />
    <List {...{ ambassadorsList }} />
  </div>
);
